import { useContext } from 'react';

import type { PostPageContextType } from './PostPageContext';
import { PostPageContext } from './PostPageContext';

export const usePostPageContext = () => {
  const context = useContext<PostPageContextType | undefined>(PostPageContext);
  if (!context) {
    // no longer warn about missing context
    // since it's used in PostCards on the home page
  }
  return context;
};
